// 定义是否折叠小仓库（选择式Api写法）
import { defineStore } from "pinia";
import { PINIA_PREFIX } from "@/config";
import { getAllCloudTags, getCloudMeta } from "@/api/cloudQuery";

interface CollectData {
  cloudQueryIds: string[];
}

interface CurrentPosition {
  latitude?: number | null;
  longitude?: number | null;
  angle?: number | null;
  zoom?: number | null;
  [k: string]: any;
}

// defineStore方法执行会返回一个函数，函数的作用就是让组件可以获取到仓库数据
const userStore = defineStore("user", {
  // 开启数据持久化
  // persist: {
  //   // enabled: true, // true 表示开启持久化保存，默认localStorage
  //   key: PINIA_PREFIX + "user", // 默认会以 store 的 id 作为 key
  //   storage: localStorage
  // },
  // 可以通过为属性指定选项来配置持久化方式persist
  persist: {
    key: PINIA_PREFIX + "user",
    storage: localStorage,
  },
  // 存储数据state
  state: () => {
    return {
      token: "",
      userInfo: {} as { [k: string]: any },
      collectData: {
        cloudQueryIds: [],
      } as CollectData,
      allCloudTags: [] as any[],
      allCloudMetas: [] as any[],
      currentPosition: null as CurrentPosition | null,
    };
  },
  // 该函数没有上下文数据，所以获取state中的变量需要使用this
  actions: {
    // Set Token
    setToken(token: string) {
      this.token = token;
    },
    // Set userInfo
    setUserInfo(userInfo: { [k: string]: any }) {
      this.userInfo = userInfo;
    },
    // set collect
    setCollect(data: CollectData) {
      this.collectData = data;
    },
    // set cloudQueryIds
    setCloudQueryIds(data: string[]) {
      this.collectData.cloudQueryIds = data;
    },
    // set allCloudTags
    setAllCloudTags(data: any[]) {
      this.allCloudTags = data;
    },

    // get allCloudTags
    async getAllTags() {
      try {
        if (this.allCloudTags.length) {
          return [null, this.allCloudTags];
        } else {
          const res: any = await getAllCloudTags();
          if (res.data && res.data.length) {
            let list = res.data[0].tags;
            list = [...new Set(list)];
            this.allCloudTags = list;
            return [null, list];
          } else {
            return [res, null];
          }
        }
      } catch (error) {
        console.log(error);
        return [error, null];
      }
    },

    // get allCloudMetas
    async getAllCloudMetas() {
      try {
        if (this.allCloudMetas.length) {
          return [null, this.allCloudMetas];
        } else {
          const res: any = await getCloudMeta();
          if (res.data) {
            this.allCloudMetas = res.data;
            return [null, res.data];
          } else {
            return [res, null];
          }
        }
      } catch (error) {
        console.log(error);
        return [error, null];
      }
    },

    // 设置定位
    setCurrentPosition(currentPosition: CurrentPosition | null) {
      this.currentPosition = currentPosition;
    },
  },
  // 计算属性
  getters: {},
});

// 对外暴露方法
export default userStore;
